<template>
  <div id="about" :class="{ mobile : isMobile }">
    <a href="https://traumgarten.bandcamp.com/" target="_blank"><img src="../assets/BACK.jpg"/></a>
    <AboutStone :isMobile="isMobile" :textcontent="homepageData.Description" :identifier="id1" style="height:40vh;width: 80vh;top:25vh;left:52vw"/>
    <AboutStone :isMobile="isMobile" :credits=true :links=false :textcontent="homepageData.credits" :identifier="id2" style="text-align:center;height:20vh;width:45vh; top:6vh;left:55vw"/>
    <AboutStone :isMobile="isMobile" :links=true :credits=false :bc="homepageData.bandcamp_link" :sc="homepageData.Soundcloud_link" :bc_image="homepageData.bandcamp_image" :sc_image="homepageData.soundcloud_image" :ig="homepageData.instagram_link" :ig_image="homepageData.instagram_image" :mail="homepageData.Emailaddress" :identifier="id3" style="height:23vh;width:150px; top:65vh;left:75vw"/>
  </div>
</template>

<script>
import axios from 'axios'
import AboutStone from "../components/AboutStone"

export default {
  name: "About",
  components: { AboutStone },
  props: ['isMobile'],
  data() {
    return {
      homepageData: null,
      id1: "stone1",
      id2: "stone2",
      id3: "stone3"
    } 
  },
  created() {
    var selfobject = this;
    axios.get('https://traumgarten.dev0ted.tech/about-traumgarten')
      .then(function (response) {
        selfobject.homepageData = response["data"];
      })
  }
}
</script>

<style scoped>

#about {
  font-size: 2.3vh;
  display:flex;
  flex-direction:row;
  position:fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  overflow:hidden;
  color:rgb(167, 167, 167);
  background-color: rgb(64, 60, 77);
  animation: aboutglow 8s infinite;
}

@keyframes aboutglow {
  0% {background-color: rgb(64, 60, 77);}
  50% {background-color: rgb(124, 124, 124);}
  100% {background-color: rgb(64, 60, 77);}
}

#about.mobile {
  overflow-y:auto;
}


#about a {
  width:455px;
  height:455px;
  top: 0;
  right: 0;
  bottom:0;
  left:0;
    margin: auto;
  box-shadow: 0px 0px 16px rgb(0, 0, 0);
  -webkit-box-shadow: 0px 0px 16px rgb(0, 0, 0);
  -moz-box-shadow: 0px 0px 16px rgb(0, 0, 0);
}

#about img {
  width:455px;
  height:455px;
}

</style>